<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 15C0 14.4477 0.447715 14 1 14H15C15.5523 14 16 14.4477 16 15C16 15.5523 15.5523 16 15 16H1C0.447715 16 0 15.5523 0 15Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8 3.97376e-08C8.55228 1.77911e-08 9 0.447715 9 1L9 12C9 12.5523 8.55229 13 8 13C7.44772 13 7 12.5523 7 12L7 1C7 0.447715 7.44772 6.16841e-08 8 3.97376e-08Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.7071 6.29289C14.0976 6.68342 14.0976 7.31658 13.7071 7.70711L8.70711 12.7071C8.31658 13.0976 7.68342 13.0976 7.29289 12.7071L2.29289 7.70711C1.90237 7.31658 1.90237 6.68342 2.29289 6.29289C2.68342 5.90237 3.31658 5.90237 3.70711 6.29289L8 10.5858L12.2929 6.29289C12.6834 5.90237 13.3166 5.90237 13.7071 6.29289Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: "IconDownload",

  props: {
    // цвет иконки
    color: {
      type: String,
      default() {
        return this.$vuetify.theme.textPrimary;
      }
    },
    // размер
    size: {
      type: String,
      default: "16"
    }
  }
};
</script>
